import { useMutation } from 'react-query';
import { tokenExchange } from '@/api/miles-and-more';

export const useTokenExchange = () => {
  return useMutation(tokenExchange);
};
